"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Optional = void 0;
var helper_1 = require("@kcutils/helper");
var alwaysTrue = function () { return true; };
var Optional = /** @class */ (function () {
    function Optional(data, extra) {
        var checking = extra !== null && extra !== void 0 ? extra : alwaysTrue;
        var exist = helper_1.generic.isExist(data) && checking(data);
        this.empty = !exist;
        this.data = data;
    }
    Optional.prototype.get = function () {
        if (this.empty)
            throw new Error("input data is empty");
        else
            return this.data;
    };
    Optional.prototype.getOrElse = function (def) {
        if (this.empty)
            return def;
        else
            return this.data;
    };
    Optional.prototype.orUndefined = function () {
        if (this.empty)
            return undefined;
        else
            return this.data;
    };
    Optional.prototype.isEmpty = function () {
        return this.empty;
    };
    Optional.prototype.isNotEmpty = function () {
        return !this.isEmpty();
    };
    return Optional;
}());
exports.Optional = Optional;
//# sourceMappingURL=Optional.js.map